import { render, staticRenderFns } from "./human-attributes.vue?vue&type=template&id=89afe9c2&"
import script from "./human-attributes.vue?vue&type=script&lang=ts&"
export * from "./human-attributes.vue?vue&type=script&lang=ts&"
import style0 from "./human-attributes.vue?vue&type=style&index=0&id=89afe9c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports